/** Normalized status label from list/show payloads */
export const getInvoiceStatusName = (row) => {
  const s = row?.status;
  if (s && typeof s === 'object') {
    return String(s.name ?? s.label ?? s.code ?? '').trim();
  }
  if (typeof s === 'string') return String(s).trim();
  return String(row?.status_name ?? row?.invoice_status ?? '').trim();
};

export const isInvoiceStatusPartial = (row) =>
  getInvoiceStatusName(row).toLowerCase() === 'partial';

/** Invoice total. `total_amount` was dropped from the table — `amount` is it. */
export const getInvoiceAmountValue = (inv) => {
  if (inv?.amount != null && inv.amount !== '') return inv.amount;
  return null;
};

export const formatInvoiceMoney = (inv) => {
  const value = getInvoiceAmountValue(inv);
  if (value == null) return '—';
  const sym = inv?.currency?.symbol || inv?.currency?.code || '$';
  return `${sym} ${value}`.trim();
};

/** Labels for SaleTypeEnum values. */
const SALE_TYPE_LABELS = {
  'front-sale': 'Front Sale',
  'up-sale': 'Up Sale',
  'front-sale-referral': 'Front Sale (Referral)',
  'up-sale-referral': 'Up Sale (Referral)',
  'down-sell': 'Down Sell',
};

export const formatSaleTypeLabel = (raw) => {
  if (raw == null || raw === '') return '—';
  const s = String(raw).trim().toLowerCase();

  return (
    SALE_TYPE_LABELS[s] ??
    String(raw)
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
};

/** Service names off the invoice's order (services live on the order now). */
export const extractInvoiceLeadServiceNames = (row) => {
  const rawList =
    row?.order?.services ??
    row?.order?.order_services ??
    row?.order?.orderServices ??
    null;

  if (!Array.isArray(rawList)) return [];

  return rawList.map((item) => item.service?.name ?? item.name).filter(Boolean);
};

/** API may return boolean, 0/1, or strings like "Yes" / "No" */
export const parseShouldSendContract = (val) => {
  if (val === true || val === 1 || val === '1') return true;
  if (val === false || val === 0 || val === '0') return false;
  const s = String(val ?? '')
    .trim()
    .toLowerCase();
  if (['yes', 'true', 'on', 'y'].includes(s)) return true;
  if (['no', 'false', 'off', 'n'].includes(s)) return false;
  return Boolean(val);
};
